'use client';
import { getUrlGtm } from '@/utils/gtmUtils';
import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoButton from 'eco-design/base/eco-button';
import EcoImg from 'eco-design/base/eco-img';
import { BannerCom } from '../../index-banner-swiper/content/BannerCom';
import './index.scss';

export default function Content({ id, data = {}, initIndex = 0 }: ContentServerProps) {
    const { layout = 'two', size, list = [], autoPlay, tabLayout } = data;
    const { locale = 'us' } = getLocal();
    return (
        <GloLayout className={`editor-index-common-card`} id={id} data={data} floorName="index-common-card">
            {layout === 'one' ? (
                <BannerCom
                    prefixCls="index-banner-swiper"
                    className="index-common-card-layout-swiper"
                    initIndex={initIndex}
                    autoPlay={autoPlay}
                    list={list}
                    size={size}
                    tabLayout={tabLayout}
                />
            ) : (
                <div className={`index-common-card-list index-common-card-layout-${layout}`}>
                    {list.map((itemA: any, index: number) => {
                        const prefixCls = `index-common-card-item`;
                        const itemLayout = itemA.layout || 'default';
                        const itemTheme = itemA.theme || 'theme';
                        const classes = classNames(prefixCls, {
                            [`${prefixCls}-layout-${itemLayout}`]: itemLayout,
                            [`${prefixCls}-theme-${itemTheme}`]: itemTheme,
                        });

                        const lGtm = {
                            ...getUrlGtm(itemA.lHref, locale, {
                                list_name: 'product_card_list',
                                product_name: itemA.title,
                                button_name: itemA.lBtnContent,
                            }),
                            position: `Homepage_middlebanner_1_${index + 1}_leftBtn`,

                            __btn_id1: `product-list-btn-l-${index}`,
                            __btn_id2: itemA.lHref,
                            __btn_type: 'href',
                        };
                        const rGtm = {
                            ...getUrlGtm(itemA.rHref, locale, {
                                list_name: 'product_card_list',
                                product_name: itemA.title,
                                button_name: itemA.rBtnContent,
                            }),
                            position: `Homepage_middlebanner_1_${index + 1}_rightBtn`,

                            __btn_id1: `product-list-btn-r-${index}`,
                            __btn_id2: itemA.rHref,
                            __btn_type: 'href',
                        };
                        return (
                            <div
                                className={classes}
                                key={index}
                                onClick={(e) => {
                                    if (itemA.lHref || itemA.rHref) {
                                        e.preventDefault();
                                        window.open(itemA.lHref || itemA.rHref);
                                        gtm.push(itemA.lHref ? lGtm : rGtm);
                                    }
                                }}
                            >
                                <EcoImg pc={itemA.pc} h5={itemA.h5} className={`${prefixCls}-img`} />
                                <div className={`${prefixCls}-msg`}>
                                    <div className={`${prefixCls}-info`}>
                                        <div className={`${prefixCls}-label`}>{itemA.label}</div>
                                        <div className={`${prefixCls}-title`}>{itemA.title}</div>
                                        <div className={`${prefixCls}-desc`}>{itemA.desc}</div>
                                        <div className={`${prefixCls}-box-btn`}>
                                            {itemA.lBtnContent && (
                                                <EcoButton
                                                    className={`GtmModuleData-btn-href product-list-btn-l-${index}`}
                                                    lTheme={itemA.theme}
                                                    lType="text"
                                                    lHref={itemA.lHref}
                                                    lChildren={itemA.lBtnContent}
                                                    lIsWithRightArrow={true}
                                                    lDataLayer={lGtm}
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                            )}
                                            {itemA.rBtnContent && (
                                                <EcoButton
                                                    className={`GtmModuleData-btn-href product-list-btn-r-${index}`}
                                                    lTheme={itemA.theme}
                                                    lType="text"
                                                    lHref={itemA.rHref}
                                                    lChildren={itemA.rBtnContent}
                                                    lIsWithRightArrow={true}
                                                    lDataLayer={rGtm}
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </GloLayout>
    );
}
